import React from 'react'
import { connect } from 'react-redux';
import styles from "./IndicatorsDashbordPers.module.css";

import {getStaff} from '../../../../actions/report'

import BtnBack from '../../helper/btnBack/BtnBack';
import GetHeader from '../../helper/getHeader/GetHeader';
import back1 from '../../../../assets/dashboard/background_1.png'
import { useEffect } from 'react';

const IndicatorsDashbordPers = ({
  getStaff,
  staff = [],
}) => {

  useEffect(() => {
    getStaff()
  }, [])

const colors = ['red', 'blue', 'green', 'blueviolet', 'yellow'];

const getSum = (data) => data?.reduce((accumulator, currentValue) => accumulator + currentValue.count, 0); //Получаем сумму баллов
const getPers = (data, sum) => data?.map(el=> `${el.count / (sum / 100)}` ).sort( (a, b) => a - b); //Получаем отсортированный список баллов в процентах

  const getValues = (data) => {
    const sum = getSum(data)
    const toPersList = getPers(data, sum);
    let persSumm = toPersList && +toPersList[0]; //Сумма процентов
    let start = toPersList && [`${colors[0]} 0% ${toPersList[0]}%`]; //Стартовый массив

    const x = toPersList?.map((el, inx) => {
      
      if (inx > 0 && toPersList.length - 1 != inx) {   
        persSumm = persSumm + +el;
        start.push(`${colors[inx]} ${toPersList[inx - 1]}% ${persSumm}%`)
      }

      if (toPersList.length - 1 == inx) {
        if (toPersList.length == 2) {
        } 
        start.push(`${colors[inx]} ${persSumm}%`)
      }
      
    })

    return start;
  }
  
  const getConicGradient = (data) => {
    const x = `conic-gradient(${getValues(data)?.map(el => `${el}`)})`; //Формируем сonic-пradient css-стиль 
    return x;
  }

  return (
    <div className={styles.wrapper}>
      <img src={back1} className={styles.bg}/>
      <GetHeader title={<>Показатели кадрового обеспечения образовательной деятельности</>}/>

      <div className={styles.wrapperInner}>
        <div className={styles.mainBlock}>
        <div className={styles.avg_mark}>
            <div className={styles.avg_mark_title}>Укомплектованность должностей <br/>преподавательского состава</div>
              {staff?.teachers_staffing_perc && 
              <div className={styles.blocks}>
                <div className={styles.avg_markChartCylinderContainer}>
              <div className={styles[`honors_degreeBlock_0`]}>
                <div className={styles.chartCylinder}
                style={{height: `${164 / 100 *  staff?.teachers_staffing_perc.total}px`}}>
                  <div className={styles.perc}>{staff?.teachers_staffing_perc.total}%</div>
                </div>
                <span style={{height: '80px'}}>Общая</span>
              </div>
              <div className={styles[`honors_degreeBlock_1`]}>
                <div className={styles.chartCylinder}
                style={{height: `${164 / 100 *  staff?.teachers_staffing_perc.military}px`}}>
                  <div className={styles.perc}>{staff?.teachers_staffing_perc.military}%</div>
                </div>
                <span style={{height: '80px'}}>Военно-служащие</span>
              </div>
              <div className={styles[`honors_degreeBlock_2`]}>
                <div className={styles.chartCylinder}
                style={{height: `${164 / 100 *  staff?.teachers_staffing_perc.civil}px`}}>
                  <div className={styles.perc}>{staff?.teachers_staffing_perc.civil}%</div>
                </div>
                <span style={{height: '80px'}}>Гражданский персонал</span>
              </div>
              </div>
              </div>
              }
          </div>

          <div className={styles.honors_degree}>
              <div className={styles.chartCylinderContainer}>
              <div className={styles.fgos_title}>Наличие <br/> у профессорско-преподавательского состава <br/> боевого отпыта</div>
              <div className={styles.chartContainer}>
                <div 
                  className={styles.pieChart}
                  style={{
                    backgroundImage: getConicGradient([{count: staff?.dissertation_defense_perc}, {count: staff?.professor_combat_exp_perc}]),
                    width: '200px',
                    height: '200px'
                  }}>
                    <span className={styles.exp_perc}>{staff?.professor_combat_exp_perc}%</span>
                </div>
              </div>
              </div>
            </div>
        </div>
        <div className={styles.mainBlock}>
        
        <div className={styles.fgos}>
            <div className={styles.fgos_title}>Обучение ППС по программам <br/> дополнительного <br/> профессиональноего образования:</div>
             <div className={styles.mainBlock}>
              <div className={styles.mainBlockList}>
                <div className={styles.mainBlockItem}><span>{staff?.additional_edu?.prof_retraining}% </span> профессиональная переподготовка</div>
                <div className={styles.mainBlockItem}><span>{staff?.additional_edu?.advanced_training}% </span> повышение квалификации</div>
                <div className={styles.mainBlockItem}><span>{staff?.additional_edu?.traineeship}% </span> стажировка</div>
              </div>
            </div>
        </div>
          
          <div className={styles.speciality}>
            <div className={styles.speciality_title}>Укомплектованность <br/> должностей <br/> преподавательского <br/> состава учебными <br/> <span>71%</span></div>
              
            <div className={styles.chartContainer}>
                {staff && staff.scientists && staff.scientists.ratio && 
                <div 
                  className={styles.pieChart}
                  style={{
                    backgroundImage: getConicGradient(staff?.scientists?.ratio?.map(el => ({count: el?.perc}))),
                    width: '300px',
                    height: '300px'
                  }}>
                </div>
                }
                <div className={styles.pieLegenda}>
                  {
                    staff?.scientists?.ratio?.sort( (a, b) => a.perc - b.perc).map((el, inx) => {
                      const index = staff?.scientists?.ratio?.length - 1 - inx;
                      return (
                        <div className={styles.entry}>
                          <div className={styles.entryColor} style={{background: `${colors[index]}`}}></div>
                          <div className={styles.entryText}
                          style={{width: '400px'}}
                          >{staff?.scientists?.ratio[index]?.name} <span>{staff?.scientists?.ratio[index].perc}</span></div>
                        </div>
                      )
                    }   
                    )
                  }
                </div>
              </div>
            </div>
        </div>
      </div>
      <BtnBack/>

    </div>
  )
}

const mapStateToProps = (state) => ({
  staff: state.report.staff
});
  
  export default connect(mapStateToProps, {
    getStaff 
  })(IndicatorsDashbordPers);